// extracted by mini-css-extract-plugin
export default {"root":"HallControlsPlugin_root__NH8Mc","reset":"HallControlsPlugin_reset__l03FL","button":"HallControlsPlugin_button__pHFh8"};